import { ArrowUpRight } from "lucide-react";

export default function ServiceCard({ n, title, body, idx = 0, testIdPrefix = "service-card" }) {
  return (
    <div
      data-testid={`${testIdPrefix}-${n}`}
      className="reveal group relative border border-bronze/25 bg-cream p-8 md:p-10 transition-all duration-500 hover:border-bronze hover:bg-beige"
      style={{ transitionDelay: `${idx * 60}ms` }}
    >
      <div className="flex items-baseline justify-between mb-6">
        <span className="font-serif text-5xl text-taupe/60 group-hover:text-bronze transition-colors">
          {n}
        </span>
        <ArrowUpRight className="text-bronze opacity-0 group-hover:opacity-100 transition-opacity duration-300" size={18} />
      </div>
      <h3 className="font-serif text-2xl sm:text-3xl text-ink leading-tight mb-3">
        {title}
      </h3>
      <p className="text-sm leading-relaxed text-ink_soft/80 font-light">
        {body}
      </p>
    </div>
  );
}
